import { render, staticRenderFns } from "./jsonDataLaws.vue?vue&type=template&id=ce94c016&"
import script from "./jsonDataLaws.vue?vue&type=script&lang=js&"
export * from "./jsonDataLaws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports